import { render, staticRenderFns } from "./WebsiteProduct.vue?vue&type=template&id=0f7f3214&scoped=true&"
import script from "./WebsiteProduct.vue?vue&type=script&lang=js&"
export * from "./WebsiteProduct.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteProduct.vue?vue&type=style&index=0&id=0f7f3214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7f3214",
  null
  
)

export default component.exports